<template>
    <div class="body">
       <add></add>
   </div>
</template>
 
<script>
import add from "@/components/moduleComponents/add";

export default {
   name: "addUser",
   components: {
       add,
   },
};
</script>
 
 